import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Card from "react-bootstrap/esm/Card";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { getAllActivePostsByAddress, selectAllActivePosts, getTrainerId } from "../../state/blogSlice";
import LiveViewSidebar from "./LiveViewSidebar";
import { useParams } from "react-router";
import parse from 'html-react-parser';


function LiveView() {
    let dispatch = useDispatch();
    let { pageAddress } = useParams();

    const [isPostsLoading, setIsPostsLoading] = useState(false);

    useEffect(() => {
        setIsPostsLoading(true);
        let payload = {
            pageAddress: pageAddress,
            action: 'getAllActivePostsByAddress'
        }
        dispatch(getAllActivePostsByAddress(payload)).then(
            res => setIsPostsLoading(false)
        )
    }, [])

    useEffect(() => {
        let payload = {
            pageAddress: pageAddress,
            action: 'getTrainerId'
        }
        dispatch(getTrainerId(payload))
    }, [])

    let activePosts = useSelector(selectAllActivePosts)


 
    return (
        <div id="containerDiv">
            <div className="text-left mb-0 ml-3"> <h1 style={{ textTransform: "capitalize", lineHeight:'1.5' }}> {pageAddress} Blogs </h1></div>
            <hr style={{ color: "black" }}/>
            <Row
                style={{
                    // backgroundColor: "#f7f8f9",
                    // padding: "50px",
                    // boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)",
                    borderRadius: "5px"
                }}>

                <Col

                    className="mx-0 px-5" lg={8}>


                    {!isPostsLoading ? <div>
                        {activePosts.map((post) => {
                            return (
                                <Card
                                    key={post.post_id}
                                    className="p-3 mb-3"
                                    style={{
                                        background: "#ffffff",
                                        border: "2px",
                                        borderRadius: '10px',
                                        boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)",
                                        maxWidth:'71vw'

                                    }}
                                    id="blogContainerCard"
                                    >
                                    <div className="mb-1">
                                        <Link
                                            to={`/${pageAddress}/blog/${post.post_slug}`}>
                                            <h3> <b> {post.post_title} </b></h3>
                                        </Link>
                                    </div>
                                    <div className="mb-3">
                                        <i><span class="far fa-clock"></span> Published on {post.date_added}</i>
                                    </div>
                                    <div>
                                        {
                                            parse(post.post_body)
                                            //parse(post.post_body.slice(0,150) + "...")
                                        }

                                    </div>
                                </Card>

                            )
                        })}
                    </div> : <Spinner animation="border" variant="primary" />}
                </Col>
                <LiveViewSidebar />
            </Row>
        </div>
    )

}
export default LiveView;
